module.exports = __webpack_public_path__ + "static/media/1-1-1.ccf00a86.png";